export default __webpack_public_path__ + "static/media/logo.b23a8902.jpg";